import EcoTextTc from 'eco-design/sections/eco-text-tc';
import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TC: React.FC = () => {
    const { t } = useLang('powerBank.TC');

    const items = [
        {
            isHead: true,
            title: t('footer_title'),
        },
        {
            isOpen: true,
            title: t('title1'),
            desc: t('desc1'),
        },
        {
            isOpen: true,
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            isOpen: true,
            title: t('title3'),
            desc: t.rich('desc3', {
                l: (v: string) => `<a class="link" href="https://${v}" target="_blank" rel="noreferrer">${v}</a>`,
            }),
        },

        {
            isOpen: true,
            title: t('title4'),
            desc: t('desc4'),
        },
        {
            isOpen: true,
            title: t('title5'),
            desc: t('desc5'),
        },
        {
            isOpen: true,
            title: t('title6'),
            desc: t.rich('desc6', {
                l: (v: string) => `<a class="link" href="${v}" target="_blank" rel="noreferrer">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title7'),
            desc: t('desc7'),
        },
        {
            isOpen: true,
            title: t('title8'),
            desc: t('desc8'),
        },
        {
            isOpen: true,
            title: t('title9'),
            desc: t.rich('desc9', {
                l: (v: string) => `<a class="link" href="${v}" target="_blank" rel="noreferrer">${v}</a>`,
                e: (v: string) => `<a class="link" href="mailto:${v}" >${v}</a>`,
            }),
        },
    ];
    return <EcoTextTc className={css.comp} items={items} />;
};
export default TC;
